module.exports = __webpack_public_path__ + "media/images/gimmicks/gimmick-wave-4f6520e0dc6cdc0b01df5d452eec2e2c.svg";